import { Component, ViewEncapsulation, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { pageTransitions } from '../../animations/page-transitions';
import { DatacenterFiltersConfiguration } from '../../datacenter/datacenter-filters-configuration';
import { DatacenterType } from '../../models/datacenter-aggrid-view';
import { FilterType } from '../../models/datacenter-filters';
import { CustomLocation } from '../../services/location.custom';
import { ListFilter } from '../../models/filter';
import { ListFilterService } from '../../services/list-filter.service';
import {
	DatacenterFilterCustomizationComponent
} from '../../datacenter/view-customization/datacenter-filter-customization.component';

@Component({
	selector: 'copo-list-filter',
	templateUrl: './list-filter.component.html',
	styleUrl: './list-filter.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,

	imports: [MatButtonModule, MatIconModule, TranslateModule, DatacenterFilterCustomizationComponent]
})
export class ListFilterComponent implements OnDestroy {
	filterTitle = '';
	datacenterType: DatacenterType;
	allFilters: FilterType[];
	addedFilters: FilterType[] = [];
	filterToEdit: {
		filterState: ListFilter;
		datacenterType: DatacenterType;
	};

	private readonly stateId = CustomLocation.GET_CURRENT_STATE_ID();

	constructor(
		private readonly router: Router,
		private readonly route: ActivatedRoute,
		private readonly defaultFilterService: DatacenterFiltersConfiguration,
		private readonly listFilterService: ListFilterService,
	) {
		if (!this.listFilterService.filterToEdit) {
			this.listFilterService.filterToEdit = <typeof listFilterService.filterToEdit>
				CustomLocation.GET_STATE('filterToEdit', this.stateId);
		}
		this.datacenterType = <DatacenterType> this.route.snapshot.queryParams['type'];
		const { filterToEdit } = this.listFilterService;
		if (!filterToEdit) {
			throw new Error('bad configuration');
		}
		this.allFilters = this.defaultFilterService.getAllFilters(filterToEdit.datacenterType);
		this.addedFilters = this.listFilterService.getPreparedFilters(filterToEdit.filterState);
		this.filterTitle = `datacenter.${ this.datacenterType }`;
		this.filterToEdit = filterToEdit;
	}

	ngOnDestroy() {
		CustomLocation.SET_STATE(
			'filterToEdit',
			this.stateId,
			this.listFilterService.filterToEdit
		);
	}

	getAppliedFilters() {
		if (this.addedFilters.length === 0) {
			return null;
		}
		return this.addedFilters.map(value => value.getFilters()).filter(filter => filter.values.length > 0);
	}

	async applyFilters() {
		const newFilter: ListFilter = {
			filterState: this.getAppliedFilters(),
			datacenterType: this.datacenterType
		};
		this.listFilterService.setCurrentFilter(newFilter);
		await this.close();
	}

	async close() {
		await this.router.navigate(['../'], { relativeTo: this.route });
	}
}
